import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { startVersionPoll } from "@/lib/versionPoll";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Feb 2026 — version poll. Detects when a new build is deployed and
// quietly reloads the page at the next idle moment, so users on
// the production site never get stranded on an old bundle because
// of their browser's HTTP cache holding onto a stale index.html.
startVersionPoll();

// Register the service worker so Android Chrome qualifies the app as
// installable and iOS Safari treats it as a PWA when added to the
// home screen. The SW itself is intentionally minimal — see
// /public/service-worker.js. Privacy-first: never caches user content.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => {
        // Registration failure is non-fatal — the app still works
        // without PWA install. Stay quiet, this isn't user-facing.
      });
  });
}
